<template>
    <div class="container">
        <h2>Thank you for your order!</h2>
    </div>
</template>

<script>
export default {
  name: 'order-thanks',
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OrderThanks.vue